import { BringPostalCodeArgs, BringResponse } from '~/lib/data-contract';
import { postRequest } from '~/shared/utils';

export async function getCityFromZip(args: BringPostalCodeArgs, apiUrl: string) {
    const request = postRequest<BringResponse>(apiUrl, args);

    return request();
}
